export default "__VITE_ASSET__BN54pBfk__"